import { create } from "zustand";

type KrakenReconnectRequiredStore = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

export const useKrakenReconnectRequiredStore = create<KrakenReconnectRequiredStore>((set) => ({
  open: false,
  setOpen: (open: boolean) => set({ open }),
}));
